import { useState } from 'react';
import file1 from "../../../../assets/file1.png"
import file2 from "../../../../assets/file2.png"
import SelectSearchApi from '../../../../Core/Fields/Floating/SelectSearchApi';
import GetIcon from '../../../../utils/Icon';

const dummyCompanyData = [
    {
        name: "Lakshmi Narain Diamond (India) Pvt. Ltd.",
        id: 1,
        code: "LND",
        children: [
            {
                name: "Lakshmi - LND",
                id: 2,
                code: "LND",
                children: [
                    {
                        name: "Department A",
                        id: 3,
                        code: "DEPT_A",
                        children: [
                            { name: "Test Team 1", id: 6, code: "TT1" },
                            { name: "Test Team 2", id: 7, code: "TT2" }
                        ]
                    },
                    { name: "Department B", id: 4, code: "DEPT_B" }
                ]
            },
            {
                name: "test - LND",
                id: 5,
                code: "LND",
                children: [
                    { name: "Test Team 1", id: 6, code: "TT1" },
                    { name: "Test Team 2", id: 7, code: "TT2" }
                ]
            },
            {
                name: "Fixed Assets - LND",
                id: 8,
                code: "LND",
                children: [
                    { name: "Machinery", id: 9, code: "MACH" },
                    { name: "Property", id: 10, code: "PROP" },
                    { name: "Vehicles", id: 11, code: "VEH" }
                ]
            },
            {
                name: "Investments - LND",
                id: 12,
                code: "LND",
                children: [
                    { name: "Stocks", id: 13, code: "STK" },
                    { name: "Bonds", id: 14, code: "BND" },
                    { name: "Mutual Funds", id: 15, code: "MF" }
                ]
            },
            {
                name: "Temporary Accounts - LND",
                id: 16,
                code: "LND",
                children: [
                    { name: "Temp Project 1", id: 17, code: "TP1" },
                    { name: "Temp Project 2", id: 18, code: "TP2" },
                    { name: "Temp Project 3", id: 19, code: "TP3" }
                ]
            }
        ]
    },
    {
        name: "Another Company Pvt. Ltd.",
        id: 20,
        code: "ACP",
        children: [
            {
                name: "Sales - ACP",
                id: 21,
                code: "ACP",
                children: [
                    { name: "North Region", id: 22, code: "NR" },
                    { name: "South Region", id: 23, code: "SR" }
                ]
            },
            {
                name: "Marketing - ACP",
                id: 24,
                code: "ACP",
                children: [
                    { name: "Digital Marketing", id: 25, code: "DM" },
                    { name: "Traditional Marketing", id: 26, code: "TM" }
                ]
            }
        ]
    }
];

const TreeNode = ({ node, isRoot, showActions }) => {
    const [expanded, setExpanded] = useState(false);

    return (
        <div className={`tree-node ${isRoot ? "root-node" : ""}`}>

            <div
                className="node-header"
                
                onClick={(e) => {
                    e.stopPropagation();
                    setExpanded((prev) => !prev);
                }}
            >   <div className="activeBG" style={{ position: 'relative', top: '-7px' }}>

                <img src={expanded ? file2 : file1} alt="file-image" width="17px" style={{ paddingLeft: '2px' }} />
                <span style={{ fontSize: 16, fontWeight: 500 }}>{node.name}</span>

                {showActions && (
                    <div
                        className="node-actions justify-content-center"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <p className='m-0 addCircle'><GetIcon iconName="AiOutlinePlus" style={{position:"relative",left:'0.5px',top:'0.4px'}} color="#fff" size={13} /></p>
                        <p className='m-0'><GetIcon iconName="BiEditAlt" color="#4B002B" size={13} /></p>
                        <p className='m-0'><GetIcon iconName="AiOutlineDelete" color="#4B002B" size={13} /></p>
                        <p className='m-0'><GetIcon iconName="LuEye" color="#4B002B" size={13} /></p>
                    </div>
                )}
                 </div>
            </div>

            {/* Children */}
            {expanded && node.children?.length > 0 && (
                <div
                    className="tree-container"
                    onClick={(e) => e.stopPropagation()}
                >
                    {node.children.map((child) => (
                        <TreeNode key={child.id} node={child} showActions={true} />
                    ))}
                </div>
            )}
        </div>
    );
};








const CompanyTreeView = () => {
    const [selectedCompany, setSelectedCompany] = useState(null);

    const handleCompanySelect = (company) => {
        setSelectedCompany(company);
    };

    return (


        <div className="px-4 py-4 " style={{ background: 'white' }}>
            <div className='row p-2' style={{ display: 'flex', gap: '15px',backgroundColor:'#eff4f9' }} >

                {/* Billing Address Section */}
                <div className="col-md-3 px-2">
                     <div style={{ flex: 1 }}>
                            <SelectSearchApi
                                list={dummyCompanyData}
                                label="Select Company"
                                style={{ height: "30px" }}
                                getOptionLabel={(item) => item.name}
                                getOptionValue={(item) => item.id}
                                value={selectedCompany}
                                onChange={(e) => handleCompanySelect(e)}
                                onApiChange={(e) => { }}
                            />
                        </div>
                   
                </div>
                <div className="col-12 px-2">
                    <div className="tree-display">
                        {selectedCompany ? (
                            <>
                                {dummyCompanyData.map((company) => company.id == selectedCompany && (
                                    <TreeNode
                                        key={company.id}
                                        node={company}
                                        isRoot={true}
                                        showActions={true}
                                    />
                                ))}
                            </>
                        ) : ''}
                    </div>


                </div>


            </div>
        </div>






    );
};

export default CompanyTreeView;